var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo"},[_c('img',{staticClass:"logo",attrs:{"src":"/img/storyfolder-logo.svg"}}),_c('span',[_vm._v(" StoryFolder "),(_vm.showBeta)?_c('span',{staticClass:"beta"},[_vm._v("Beta")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }